import {
  Box,
  Container,
  FormControlLabel,
  Grid,
  Switch,
  Typography
} from "@mui/material";
import React, { useContext, useState } from "react";
import { getLocalStorage } from "../../components/layout/cookies/CookieFunctions";
import { AuthContext } from "../../components/user/BCPAuthProvider";
import HelpButton from "../../components/utilities/HelpButton";

export default function BetaTestFeatures() {
  const authContext = useContext(AuthContext);
  const [allowTranslations, setAllowTranslations] = useState(
    authContext?.authState?.identity?.isAdmin === true ||
      authContext?.authState?.identity?.betaUser === "true" ||
      getLocalStorage("allowTranslations") === "true"
  );

  return (
    <Box width="100%">
      <Container maxWidth="lg" sx={{ pt: 2, pb: 2 }}>
        <Grid container sx={{ p: 2, gap: 2 }}>
          <Grid item xs={12}>
            <Typography
              variant="h2"
              component="h3"
              fontWeight="700"
              gutterBottom
              sx={{ mb: 4 }}
            >
              {"Beta Test Features"}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="body1" color={"textSecondary"}>
              {
                "This page allows you to enable or disable beta test features while not being logged in. If you are logged in, your account status and settings will determine your access to these features and will override any settings on this page. Beta test features are experimental and may not be fully functional. They are provided for testing purposes only and may be removed at any time."
              }
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <FormControlLabel
              label={
                <Typography>
                  {"Language Translations"}
                  <HelpButton
                    title={
                      "Toggle language translations on or off. This will require a page reload to take effect. This page is not translated, but if you enable this feature, you will be able to select a language from the language selector in the header."
                    }
                  />
                </Typography>
              }
              control={
                <Switch
                  checked={allowTranslations}
                  onChange={(e) => {
                    setAllowTranslations(e.target.checked);
                    if (e.target.checked) {
                      localStorage.setItem("allowTranslations", "true");
                    } else {
                      localStorage.removeItem("allowTranslations");
                    }
                  }}
                />
              }
              labelPlacement="end"
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
